import { useCallback } from "react";
import { EncryptData } from "../../../utils/Encrypt";

export const useEncrypt = () => {
  const getEncrypt = useCallback((user_id, time, user_secret) => {
    return EncryptData(user_id + time + user_secret);
  }, []);

  return { getEncrypt };
};

export default useEncrypt;
